// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSliderArrowBig_root__2ziue","arrow":"IconSliderArrowBig_arrow__1K5WV"};